import { gql } from '@apollo/client';

export const REPORT_CARD_CHATBOT_ENABLED = gql`
  query ReportCardChatbotEnabled($playerAssessmentId: ID!, $token: String) {
    reportCardChatbotEnabled(playerAssessmentId: $playerAssessmentId, token: $token)
  }
`;
